export default {
  local: 'http://localhost:6003',
  development: 'http://betalogin.tron.com.br',
  production: 'http://login.tron.com.br',
};
